import {getPlaceOrderDeliveryAddress} from '../selectors/PlaceOrderSelectors/PlaceOrderPropertiesSelectors';
import attributes from '../tracking/attributes';
import Track from '../utils/tracking';

const getDeliveryAddressType = state => state.delivery.deliveryType;
const getDeliveryAddress = state => getPlaceOrderDeliveryAddress(state);
const hasStoredPudoAddressExist = state => (state.pudo.savedAddresses.length >= 1);

const residentialAddressAttribute = (state) => {
  const address = getDeliveryAddress(state);
  if (address.addressId) {
    const attributesArray = [];
    attributesArray.push(attributes.getAttribute('addressType', 'stored address'));
    const addressInStore = state.address.deliveryAddressList.addresses[address.legacyId]
      || state.address.deliveryAddressList.addresses[address.addressId];
    if (addressInStore) {
      attributesArray.push(attributes.getAttribute('countryCode', addressInStore.country));
    }
    return attributesArray;
  }
  const attributesArray = [];
  attributesArray.push(attributes.getAttribute('addressType', 'new address'));
  let {countryCode} = address;
  if (countryCode === undefined) {
    countryCode = state.address.deliveryAddressList.addresses[''].country;
  }
  attributesArray.push(attributes.getAttribute('countryCode', countryCode));
  return attributesArray;
};

const clickAndCollectAddressAttribute = (state) => {
  if (hasStoredPudoAddressExist(state)) {
    const address = getDeliveryAddress(state);
    const attributesArray = [];
    attributesArray.push(attributes.getAttribute('addressType', 'click and collect'));
    attributesArray.push(attributes.getAttribute('countryCode', address.countryCode));
    return attributesArray;
  }
  return [];
};

const getDeliveryAddressAttribute = () => (_, getState) => {
  try {
    const deliveryType = getDeliveryAddressType(getState());
    if (deliveryType !== 'pudo') {
      return residentialAddressAttribute(getState());
    }
    return clickAndCollectAddressAttribute(getState());
  } catch (error) {
    Track.track(`error caught in reading address attribute${error}`);
    return [];
  }
};

export default getDeliveryAddressAttribute;
